import moment from "moment";
import { ACCOUNTS, ACTIVE_CUSTOMERS, BASE_URL, COUNTRIES, CUSTOM_COLUMNS, EDGE_ECOMM, INPUT_FORMS, SUB_CHANNELS, USERS } from "../../constant/apiEndpoints";
import { IActiveCustomer, IColumn, IColumnAPI, ISubChannel } from "../../reducer/ECommCustomers/_interfaces";
import { CLEAR_ACTIVE_CUSTOMERS, SET_ADDITIONAL_COLUMNS, SET_COUNTRIES, SET_COUNTRIES_LOADING, SET_DATA, SET_DATA_FOR_APPROVAL, SET_DATA_LOADING, SET_ERROR, SET_SUB_CHANNELS, SET_SUB_CHANNELS_LOADING, SET_SUCCESS, SET_UPDATED_ROWS } from "../../reducer/ECommCustomers/constants"
import { IAPIReturn } from "../../services/_interfaces";
import APIService from "../../services/APIService";

//Load prerequisits actions
export const loadSubChannels = (selected_form:string) => async (dispatch:any) => {
    dispatch({type: SET_SUB_CHANNELS_LOADING, payload: true});

    
    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + SUB_CHANNELS + `?selected_form=${selected_form}`;
    const response:IAPIReturn = await new APIService().get(url);

    if (response.error) {
        console.log("error in user countrylist API", response.results.message);
        dispatch({type: SET_ERROR, payload: response.results.message});
    } else {
        const transformedData = response.results
            .filter(({is_active}:ISubChannel) => is_active)
            .map(({ id, name }:ISubChannel) => ({
                label: name,
                value: id,
            }));
        dispatch({type: SET_SUB_CHANNELS, payload: transformedData});
    }
    dispatch({type: SET_SUB_CHANNELS_LOADING, payload: false});
}

export const loadCountries = (formId:string) => async (dispatch:any) => {
    dispatch({type: SET_COUNTRIES_LOADING, payload: true});
    
    const url = BASE_URL + ACCOUNTS + USERS + COUNTRIES + `?form_id=${formId}`;
    const response:IAPIReturn = await new APIService().get(url);
    
    if (response.error) {
        console.log("error in user countrylist API", response.results.message);
        dispatch({type: SET_ERROR, payload: response.results.message});
    } else {
        dispatch({type: SET_COUNTRIES, payload: response.results});
    }

    dispatch({type: SET_COUNTRIES_LOADING, payload: false});
}

// General page actions
export const loadData = (formId:string, page:number, params:any = {}, mergeWithData?:IActiveCustomer[]) => async (dispatch:any) => {
    dispatch({type: SET_DATA_LOADING, payload: true});
    let paramString = Object.entries(params).reduce((a:string, [key, value], i) => a + `&${key}=${value}`, '')

    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + ACTIVE_CUSTOMERS + `?selected_form=${formId}${paramString}`;
    const response:IAPIReturn = await new APIService().get(url);
    
    if (response.error) {
        console.log("error in active customers list API", response.results.message);
        dispatch({type: SET_ERROR, payload: response.results.message});
    } else {
        dispatch(setCustomersListData([...response.results, ...(mergeWithData || [])]));
    }

    dispatch({type: SET_DATA_LOADING, payload: false});
}

export const updateData = (formId:string, data:IActiveCustomer[], country_id:string) => async (dispatch:any) => {
    dispatch({type: SET_DATA_LOADING, payload: true});
    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + ACTIVE_CUSTOMERS + `/?selected_form=${formId}`;
    
    const newData = data.reduce((a:IActiveCustomer[], e:IActiveCustomer) => [
        ...a,
        {
            ...e,
            ...(typeof e.id === 'number' ? {id: e.id} : {id: null}),
            created_at: e.created_at || moment().format(),
        }
    ], []);

    const responseCreate:IAPIReturn = await new APIService().post(url, newData);

    if (responseCreate.error) {
        dispatch({type: SET_DATA_LOADING, payload: false});
        console.log("error in active customers create list API", responseCreate.results.message);
        dispatch({type: SET_ERROR, payload: responseCreate.results.message});
    } else {
        dispatch(loadData(formId, -1, { country_id }))
        dispatch({type: SET_SUCCESS, payload: 'Data was send for approval successfully'});
    }
}

export const getColumns = (formId:string) => async (dispatch:any) => {
    dispatch({type: SET_DATA_LOADING, payload: true});

    // dispatch({type: SET_ADDITIONAL_COLUMNS, payload: column});

    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + CUSTOM_COLUMNS + `?selected_form=${formId}`;
    const response:IAPIReturn = await new APIService().get(url);

    if (response.error) {
        console.log("error in active customers getcustom columns API", response.results.message);
        dispatch({type: SET_ERROR, payload: response.results.message});
    } else {
        const transformedData:IColumn[] = response.results
            .map((column:IColumnAPI) => ({
                id: column.id,
                dataIndex: column.data_index,
                title: column.display_name,
                width: 160,
                editable: true,
            }));
        dispatch({type: SET_ADDITIONAL_COLUMNS, payload: transformedData});
    }

    
    dispatch({type: SET_DATA_LOADING, payload: false});
}

export const addColumn = (formId:string, column:{data_index: string, display_name:string}, country_id?:string) => async (dispatch:any) => {
    dispatch({type: SET_DATA_LOADING, payload: true});

    // dispatch({type: SET_ADDITIONAL_COLUMNS, payload: column});

    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + CUSTOM_COLUMNS + `?selected_form=${formId}`;
    const responseCreate:IAPIReturn = await new APIService().post(url, column);

    if (responseCreate.error) {
        console.log("error in active customers create new column API", responseCreate.results.message);
        dispatch({type: SET_ERROR, payload: responseCreate.results.message});
    } else {
        dispatch(getColumns(formId));
        if (country_id) {
            dispatch(loadData(formId, -1, { country_id }))
        }
        dispatch({type: SET_SUCCESS, payload: 'New column was successfully created'});
    }
}

export const deleteColumn = (formId:string, id:number, country_id?:string) => async (dispatch:any) => {
    dispatch({type: SET_DATA_LOADING, payload: true});

    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + CUSTOM_COLUMNS + `?selected_form=${formId}`;
    const response:IAPIReturn = await new APIService().delete(url, {id});

    
    if (response.error) {
        dispatch({type: SET_DATA_LOADING, payload: false});
        console.log("error in active customers delete column API", response.results.message);
        dispatch({type: SET_ERROR, payload: response.results.message});
    } else {
        dispatch(getColumns(formId));
        if (country_id) {
            dispatch(loadData(formId, -1, { country_id }))
        }
        dispatch({type: SET_SUCCESS, payload: 'Column was successfully deleted'});
    }
}

export const deleteData = (formId:string, data:(number|string)[], country_id:string, mergeWithData?:IActiveCustomer[]) => async (dispatch:any) => {
    dispatch({type: SET_DATA_LOADING, payload: true});
    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + ACTIVE_CUSTOMERS + `/?selected_form=${formId}`;
    const response:IAPIReturn = await new APIService().delete(url, data);

    
    if (response.error) {
        dispatch({type: SET_DATA_LOADING, payload: false});
        console.log("error in sending records for deletion API", response.results.message);
        dispatch({type: SET_ERROR, payload: response.results.message});
    } else {
        dispatch(loadData(formId, -1, { country_id }, mergeWithData))
        dispatch({type: SET_SUCCESS, payload: 'Data was send for deletion approval successfully'});
    }

}

export const resetUpdateRows = () => (dispatch:any) => {
    dispatch({type: SET_UPDATED_ROWS, payload: {
        newUpdatedRows: []
    }});
}

export const addUpdatedRow = (row:IActiveCustomer, updatedRows:IActiveCustomer[], data:IActiveCustomer[]) => async (dispatch:any) => {
    const { id } = row;

    const alreadyEdited = updatedRows.findIndex((currentRow) => id === currentRow.id);
    let newUpdatedRows:IActiveCustomer[] = [];
    
    if (alreadyEdited >= 0) {
        newUpdatedRows = updatedRows.reduce((all:IActiveCustomer[], currentRow:IActiveCustomer) => [
            ...all,
            ...(id === currentRow.id ? [row] : [currentRow])
        ], []);
    } else {
        newUpdatedRows = [ ...updatedRows, row ];
    }
    
    dispatch({type: SET_UPDATED_ROWS, payload: {
        newUpdatedRows,
        data
    }});
} 

export const setCustomersListData = (data:IActiveCustomer[]) => async (dispatch:any) => {
    dispatch({type: SET_DATA, payload: data});
}


// Admin page actions
export const setDataForApproval = (data:IActiveCustomer[]) => async (dispatch:any) => {
    dispatch({type: SET_DATA_FOR_APPROVAL, payload: data});
}

export const loadDataForApproval = (formId:string, page:number, params:any = {}) => async (dispatch:any) => {
    dispatch({type: SET_DATA_LOADING, payload: true});
    let paramString = Object.entries(params).reduce((a:string, [key, value]) => a + `&${key}=${value}`, '')

    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + ACTIVE_CUSTOMERS + `/approval?selected_form=${formId}${paramString}`;
    const response:IAPIReturn = await new APIService().get(url);
    
    if (response.error) {
        console.log("error in active customers list API", response.results.message);
        dispatch({type: SET_ERROR, payload: response.results.message});
    } else {
        dispatch(setDataForApproval(response.results));
    }

    dispatch({type: SET_DATA_LOADING, payload: false});
}

export const adminAppoveRecords = (formId:string, ids:number[], country_id:string, recordsForRejection:number[]) => async (dispatch:any) => {
    dispatch({type: SET_DATA_LOADING, payload: true});

    if (recordsForRejection.length > 0)
        dispatch(adminDeleteRecords(formId, recordsForRejection, country_id, false));

    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + ACTIVE_CUSTOMERS + `/approval/?selected_form=${formId}`;
    const response:IAPIReturn = await new APIService().post(url, ids);

    if (response.error) {
        dispatch({type: SET_DATA_LOADING, payload: false});
        console.log("error in approving records API", response.results.message);
        dispatch({type: SET_ERROR, payload: response.results.message});
    } else {
        dispatch({type: SET_SUCCESS, payload: 'Entries were approved successfully'});
        dispatch(loadDataForApproval(formId, 1, { country_id }));
    }
}
export const adminDeleteRecords = (formId:string, ids:number[], country_id:string, reload:boolean = true) => async (dispatch:any) => {
    dispatch({type: SET_DATA_LOADING, payload: true});
    
    const url = BASE_URL + INPUT_FORMS + EDGE_ECOMM + ACTIVE_CUSTOMERS + `/approval/?selected_form=${formId}`;
    
    const response:IAPIReturn = await new APIService().delete(url, ids);
    if (response.error) {
        console.log("error in deleting records API", response.results.message);
        dispatch({type: SET_ERROR, payload: response.results.message});
    } else {
        if (reload) {
            dispatch({type: SET_SUCCESS, payload: 'Entries were rejected successfully'});
            dispatch(loadDataForApproval(formId, 1, { country_id }));
        } else {
            dispatch({type: SET_SUCCESS, payload: 'Entries with matching customer name were reset successfully'});
        }
    }

    dispatch({type: SET_DATA_LOADING, payload: false});
}

//General actions
export const clearData = () => (dispatch:any) => dispatch({type: CLEAR_ACTIVE_CUSTOMERS});
export const clearError = () => (disaptch:any) => disaptch({ type: SET_ERROR, payload: '' });
export const clearSuccess = () => (disaptch:any) => disaptch({ type: SET_SUCCESS, payload: '' });